import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Tabs, Switch } from 'antd';
import Pusher from 'pusher-js';
import InfiniteScroll from '../InfiniteScroller/InfiniteScroller';
import NotificationItem from './NotificationItem';
import { NOTIFICATION_CONFIG, TAP_HEADER_HEIGHT, TAP_FOOTER_HEIGHT, DRAWER_HEADER_HEIGHT, TAB_HEADER_HEIGHT, NOTIFICATIONS, OEM_PORTAL, SUPPORT_PORTAL } from './Constants';
import Loader from '../../atoms/Loader';
import { BrowserNotification } from '../../utils/helper.browsernotification';
import { deepClone, getEmailId, getNotificationCount, isEmpty, renderIf } from '../../utils/helper';
import { getActiveTab, getNotificationObject, getTabsForNotifications } from '../../utils/helper.notification';
import { EMPTY_OBJECT, EMPTY_STRING } from '../../constants/Constants';
import IconWithBadge from '../../molecules/IconWithBadge'; // Todo : Replace this with actual tekion component
import styles from './Notifications.module.scss';
const {
  NOTIFICATIONS_PUSHER_APP_KEY,
  NOTIFICATIONS_PUSHER_APP_CLUSTER,
  SUPPORT_BRAND_ID
} = process.env || {};
const notificationObjects = {};
export class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.componentWillUnmount = () => {
      this.pusher.disconnect();
    };
    this.handleInfiniteOnLoad = () => {
      const {
        fetchNotifications,
        apiBaseUrl,
        notificationLoading
      } = this.props;
      const {
        activeTab,
        activePage
      } = this.state;
      if (notificationLoading) return;
      const page = activePage + 1;
      fetchNotifications(apiBaseUrl, page, activeTab);
      this.setState({
        activePage: page
      });
    };
    this.onClickNotificationIcon = () => {
      const {
        setNotificationHasMore
      } = this.props;
      this.setState({
        showNotificationPopover: true,
        onlyUnread: false
      }, () => {
        setNotificationHasMore(true);
      });
    };
    this.onCloseNotification = () => {
      const {
        setNotifications,
        setNotificationHasMore,
        setNotificationFilter
      } = this.props;
      this.setState({
        showNotificationPopover: false,
        activePage: 0
      }, () => {
        setNotifications([]);
        setNotificationHasMore(false);
        setNotificationFilter({});
      });
    };
    this.connectPusher = () => {
      const {
        apiBaseUrl,
        pusher
      } = this.props;
      const currActiveTab = getActiveTab();
      const {
        authEndPoint,
        channel,
        ticketNotificationPusherEvent,
        ticketNotificationUpdatePusherEvent,
        getToken,
        tokenPropertyName
      } = NOTIFICATION_CONFIG[currActiveTab];
      this.pusher = !isEmpty(pusher) ? pusher : new Pusher(NOTIFICATIONS_PUSHER_APP_KEY, {
        cluster: NOTIFICATIONS_PUSHER_APP_CLUSTER,
        authEndpoint: "".concat(apiBaseUrl).concat(authEndPoint),
        auth: {
          headers: {
            [tokenPropertyName]: getToken()
          }
        }
      });
      this.pusherChannel = this.pusher.subscribe(channel.replace('<email>', getEmailId()));
      this.pusherChannel.bind(ticketNotificationPusherEvent, data => this.onUserNotification(data));
      this.pusherChannel.bind(ticketNotificationUpdatePusherEvent, data => this.onUserNotificationUpdate(data));
    };
    this.onUserNotificationUpdate = pusherNotification => {
      const {
        notifications,
        setNotifications,
        setUnreadNotificationCount,
        notificationFilter
      } = this.props;
      const {
        data = EMPTY_OBJECT
      } = pusherNotification;
      const updatedNotifications = deepClone(notifications);
      let notificationsToDisplay = [];
      const {
        mark_all_read: markAllAsRead
      } = data;
      if (markAllAsRead) {
        updatedNotifications.forEach(notification => {
          const updatedNotifcation = notification;
          updatedNotifcation.isRead = markAllAsRead;
        });
      } else {
        const notificationIndex = notifications.findIndex(notification => notification.id === data.id);
        if (notificationIndex > -1) {
          const notificationToBeUpdated = updatedNotifications[notificationIndex];
          const {
            isRead
          } = notificationToBeUpdated;
          notificationToBeUpdated.isRead = !isRead;
          updatedNotifications[notificationIndex] = notificationToBeUpdated;
        }
      }
      if (!isEmpty(notificationFilter)) {
        notificationsToDisplay = updatedNotifications.filter(_ref => {
          let {
            isRead
          } = _ref;
          return isRead === false;
        });
      } else {
        notificationsToDisplay = updatedNotifications;
      }
      setUnreadNotificationCount(data.count);
      setNotifications(notificationsToDisplay);
    };
    this.onUserNotification = pusherNotification => {
      const {
        data = EMPTY_OBJECT
      } = pusherNotification;
      const {
        message = EMPTY_STRING,
        body = EMPTY_STRING,
        id = EMPTY_STRING,
        brand_id: brandId = EMPTY_STRING
      } = data;
      if (isEmpty(SUPPORT_BRAND_ID) || SUPPORT_BRAND_ID === brandId) {
        var _pusherObj;
        const {
          notifications,
          setNotifications,
          setUnreadNotificationCount,
          unreadNotificationsCount
        } = this.props;
        let pusherObj = {};
        pusherObj = getNotificationObject(data);
        notificationObjects[id] = this.browserNotification.showNotification(__('TAP - {{message}}', {
          message
        }), body || ((_pusherObj = pusherObj) === null || _pusherObj === void 0 ? void 0 : _pusherObj.itemId), true, {}, this.onClickNotificationIcon);
        if (notifications.findIndex(notification => notification.id === pusherObj.id) < 0) {
          const updatedNotifications = [...notifications];
          updatedNotifications.unshift(pusherObj);
          setNotifications(updatedNotifications);
          setUnreadNotificationCount(parseInt(unreadNotificationsCount + 1, 10));
        }
      }
    };
    this.tabChange = activeTab => {
      this.setState({
        activeTab
      });
    };
    this.filterNotification = value => {
      const {
        setNotificationFilter,
        fetchNotifications,
        apiBaseUrl,
        setNotifications
      } = this.props;
      const {
        activeTab
      } = this.state;
      setNotifications([]);
      if (value) {
        const filter = {
          read: false
        };
        setNotificationFilter(filter);
      } else {
        setNotificationFilter({});
      }
      this.setState({
        activePage: 1,
        onlyUnread: value
      });
      fetchNotifications(apiBaseUrl, 1, activeTab);
    };
    this.renderTitle = () => {
      const {
        onlyUnread
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.notificationHeader
      }, NOTIFICATIONS.LABEL, /*#__PURE__*/React.createElement("div", {
        className: styles.notificationFilter
      }, NOTIFICATIONS.ONLY_SHOW_UNREAD_TOGGLE, " ", /*#__PURE__*/React.createElement(Switch, {
        onChange: this.filterNotification,
        checked: onlyUnread
      })));
    };
    this.updateNotification = notification => {
      const {
        updateNotification,
        apiBaseUrl
      } = this.props;
      const {
        activeTab
      } = this.state;
      const {
        id
      } = notification;
      updateNotification(apiBaseUrl, activeTab, {
        id
      });
    };
    this.markAllNotificationAsRead = () => {
      const {
        updateNotification,
        apiBaseUrl
      } = this.props;
      const {
        activeTab
      } = this.state;
      updateNotification(apiBaseUrl, activeTab, {
        mark_all_read: true
      }, true);
    };
    this.renderNotifications = () => {
      const {
        notifications,
        hasMore,
        apiBaseUrl,
        notificationLoading,
        isPartnerSite
      } = this.props;
      const {
        activeTab
      } = this.state;
      const {
        redirectUrl,
        bulkUpdateRedirectUrl
      } = NOTIFICATION_CONFIG[activeTab];
      const {
        height
      } = document.body.getBoundingClientRect();
      const notificationHeight = height - TAP_HEADER_HEIGHT - DRAWER_HEADER_HEIGHT - TAB_HEADER_HEIGHT - TAP_FOOTER_HEIGHT - 60;
      const {
        TabPane
      } = Tabs;
      return /*#__PURE__*/React.createElement(React.Fragment, null, notificationLoading && /*#__PURE__*/React.createElement(Loader, {
        id: "notification"
      }), /*#__PURE__*/React.createElement(Tabs, {
        defaultActiveKey: activeTab,
        onChange: this.tabChange
      }, getTabsForNotifications(isPartnerSite).map(tab => /*#__PURE__*/React.createElement(TabPane, {
        key: tab,
        tab: NOTIFICATION_CONFIG[tab].title
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.notificationMarkAllread,
        role: "button",
        tabIndex: 0,
        onClick: this.markAllNotificationAsRead
      }, NOTIFICATIONS.MARK_ALL_AS_READ), /*#__PURE__*/React.createElement("div", {
        className: styles.headerNotifications,
        style: {
          height: notificationHeight
        }
      }, /*#__PURE__*/React.createElement(InfiniteScroll, {
        hasMore: !notificationLoading && hasMore,
        loadMore: this.handleInfiniteOnLoad,
        pageStart: 0,
        useWindow: false
      }, renderIf(!isEmpty(notifications), () => /*#__PURE__*/React.createElement(React.Fragment, null, notifications.map(notification => /*#__PURE__*/React.createElement(NotificationItem, {
        key: notification.id,
        apiBaseUrl: apiBaseUrl,
        notification: notification,
        redirectUrl: notification.eventType === 'ticket_bulk_update' ? bulkUpdateRedirectUrl : redirectUrl,
        updateNotification: this.updateNotification
      }))))), renderIf(!isEmpty(notifications) && !hasMore, () => /*#__PURE__*/React.createElement("div", {
        className: styles.notificationEndMessage
      }, /*#__PURE__*/React.createElement("span", {
        className: "icon-flag-filled"
      }), NOTIFICATIONS.ALL_NOTIFICATIONS_FROM_LAST_30_DAYS)), renderIf(isEmpty(notifications) && !notificationLoading, () => /*#__PURE__*/React.createElement("div", {
        className: styles.notificationEndMessage
      }, /*#__PURE__*/React.createElement("span", {
        className: "icon-flag-filled"
      }), NOTIFICATIONS.NO_NOTIFICATIONS_FROM_LAST_30_DAYS))));
    };
    this.state = {
      showNotificationPopover: false,
      activeTab: getActiveTab(),
      activePage: 0,
      onlyUnread: false
    };
    this.email = getEmailId();
    this.browserNotification = null;
  }
  componentDidMount() {
    this.connectPusher();
    this.browserNotification = new BrowserNotification();
    window.onbeforeunload = () => {
      this.browserNotification.clearAllNotifications();
    };
  }
  render() {
    const {
      showNotificationPopover
    } = this.state;
    const {
      unreadNotificationsCount
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconWithBadge, {
      badgeContent: getNotificationCount(parseInt(unreadNotificationsCount, 10)),
      iconName: "icon-notification",
      onClick: this.onClickNotificationIcon
    }), /*#__PURE__*/React.createElement(Drawer, {
      closable: true,
      className: styles.tapNotification,
      placement: "right",
      title: this.renderTitle(),
      visible: showNotificationPopover,
      width: "60rem",
      onClose: this.onCloseNotification
    }, this.renderNotifications()));
  }
}
Notifications.propTypes = {
  notifications: PropTypes.array,
  setNotifications: PropTypes.func,
  fetchNotifications: PropTypes.func,
  hasMore: PropTypes.bool,
  apiBaseUrl: PropTypes.string,
  setNotificationFilter: PropTypes.object,
  notificationLoading: PropTypes.bool,
  updateNotification: PropTypes.func,
  setNotificationHasMore: PropTypes.bool,
  pusher: PropTypes.object,
  isPartnerSite: PropTypes.bool,
  notificationsBaseUrl: PropTypes.string
};
Notifications.defaultProps = {
  notifications: [],
  setNotifications: () => {},
  fetchNotifications: () => {},
  hasMore: true,
  apiBaseUrl: '',
  setNotificationFilter: {},
  notificationLoading: false,
  updateNotification: () => {},
  setNotificationHasMore: false,
  pusher: EMPTY_OBJECT,
  isPartnerSite: false,
  notificationsBaseUrl: EMPTY_STRING
};
export default Notifications;